import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useContext, useEffect } from "react";
import axios, { HttpStatusCode } from "axios";
import { AppExperimentContext } from "@catchoftheday/analytics";
import { STEPUP_COMPLETE_QUERY_PARAM, STEPUP_ENDPOINT, STEPUP_PROXY_ENDPOINT, STEPUP_SESSION_ENDPOINT, STEPUP_SESSION_KEY } from "../../consts";
export var useStepUpChallenge = function useStepUpChallenge(_ref) {
  var onStepUpChallengeSuccess = _ref.onStepUpChallengeSuccess,
      onStepUpChallengeError = _ref.onStepUpChallengeError;

  var _useContext = useContext(AppExperimentContext),
      getExperiments = _useContext.getExperiments;

  var _getExperiments = getExperiments(["step_up_challenge_web_jul_24"]),
      _getExperiments$exper = _slicedToArray(_getExperiments.experiments, 1),
      stepUpExperiment = _getExperiments$exper[0],
      loading = _getExperiments.loading;

  var isStepUpEnabled = !loading && (stepUpExperiment === null || stepUpExperiment === void 0 ? void 0 : stepUpExperiment.bucket) === 1;
  var getPathWithProxy = useCallback(function (path) {
    return !isStepUpEnabled ? path : "".concat(STEPUP_PROXY_ENDPOINT, "?destination=").concat(encodeURIComponent(path));
  }, [isStepUpEnabled]);
  var setSessionPayload = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sessionPayload) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return axios.post(STEPUP_SESSION_ENDPOINT, _defineProperty({}, STEPUP_SESSION_KEY, sessionPayload));

            case 3:
              _context.next = 10;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              _context.next = 9;
              return onStepUpChallengeError();

            case 9:
              return _context.abrupt("return");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onStepUpChallengeError]);
  var getSessionPayload = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$axios$get, data, _error$response, error;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return axios.get(STEPUP_SESSION_ENDPOINT);

          case 3:
            _yield$axios$get = _context2.sent;
            data = _yield$axios$get.data;
            return _context2.abrupt("return", data[STEPUP_SESSION_KEY]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            error = _context2.t0;

            if (!(((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === HttpStatusCode.NotFound)) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", undefined);

          case 13:
            _context2.next = 15;
            return onStepUpChallengeError();

          case 15:
            return _context2.abrupt("return");

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  })), [onStepUpChallengeError]);
  var triggerStepUpChallenge = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(sessionPayload) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (isStepUpEnabled) {
                _context3.next = 4;
                break;
              }

              _context3.next = 3;
              return onStepUpChallengeSuccess(sessionPayload);

            case 3:
              return _context3.abrupt("return");

            case 4:
              _context3.t0 = sessionPayload;

              if (!_context3.t0) {
                _context3.next = 8;
                break;
              }

              _context3.next = 8;
              return setSessionPayload(sessionPayload);

            case 8:
              window.location.assign("".concat(STEPUP_ENDPOINT, "?returnTo=").concat(encodeURIComponent(window.location.pathname)));

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [isStepUpEnabled, onStepUpChallengeSuccess, setSessionPayload]);
  var handleStepUpChallengeResponse = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var urlParams, isChallengeCompleteParam, sessionPayload;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(true && isStepUpEnabled)) {
              _context4.next = 16;
              break;
            }

            urlParams = new URLSearchParams(window.location.search);
            isChallengeCompleteParam = urlParams.get(STEPUP_COMPLETE_QUERY_PARAM);
            window.history.replaceState({}, "", "".concat(window.location.pathname));

            if (!isChallengeCompleteParam) {
              _context4.next = 16;
              break;
            }

            _context4.next = 7;
            return getSessionPayload();

          case 7:
            sessionPayload = _context4.sent;
            _context4.t0 = isChallengeCompleteParam === "true";

            if (!_context4.t0) {
              _context4.next = 12;
              break;
            }

            _context4.next = 12;
            return onStepUpChallengeSuccess(sessionPayload);

          case 12:
            _context4.t1 = isChallengeCompleteParam === "false";

            if (!_context4.t1) {
              _context4.next = 16;
              break;
            }

            _context4.next = 16;
            return onStepUpChallengeError(sessionPayload);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [getSessionPayload, isStepUpEnabled, onStepUpChallengeError, onStepUpChallengeSuccess]);
  useEffect(function () {
    handleStepUpChallengeResponse();
  }, [handleStepUpChallengeResponse]);
  return {
    getPathWithProxy: getPathWithProxy,
    triggerStepUpChallenge: triggerStepUpChallenge
  };
};